// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import { VrPresets } from 'utils/vrCampaign';

import { Flex, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import { Budget } from 'components/VrCampaignBuilder/components/CustomResponsesAndBudget/Budget';
import { Responses } from 'components/VrCampaignBuilder/components/CustomResponsesAndBudget/Responses';

import { selectVrCampaignPreset } from 'store/models/vrCampaign';
import { useSelector } from 'store/utils';

export const CustomResponsesAndBudget: FC = () => {
    const selectedPreset = useSelector(selectVrCampaignPreset);

    const { isMobile } = useBreakpoint();

    if (selectedPreset !== VrPresets.Custom) {
        return null;
    }

    return (
        <>
            <Flex direction={isMobile ? 'column' : 'row'} gap={24}>
                <Responses />
                <Budget />
            </Flex>
            <VSpacing default={24} />
        </>
    );
};
